import { ProductStockRecord } from './stock.types';

/**
 * Upsert por `id` de records `productStock` in-memory: los `updates` pisan al existente y los nuevos
 * se agregan. Sirve para aplicar valores absolutos ya conocidos y frescos —los que devuelve el
 * callable de creación de pedido, en éxito (`updatedProductStock`) y en error (`stockErrors[].item`),
 * ambos de transaction-time— sin refetchear `/stock`, que lee la réplica eventualmente consistente.
 */
export function mergeProductStockRecords(
  productStock: ProductStockRecord[],
  updates: ProductStockRecord[],
): ProductStockRecord[] {
  if (updates.length === 0) {
    return productStock;
  }

  const updateById = new Map(updates.map(update => [update.id, update]));
  const merged = productStock.map(record => updateById.get(record.id) ?? record);

  const existingIds = new Set(productStock.map(record => record.id));

  updateById.forEach(update => {
    if (!existingIds.has(update.id)) {
      merged.push(update);
    }
  });

  return merged;
}
